<template>
  <div
    class="bar-graph-widget"
    :style="style"
  >
    <circles-bar
      v-for="(value, index) in scaledValues"
      :key="index"
      class="bar"
      :length="value.length"
      :label="value.label"
      :bold="value.bold"
      :circle-size="widget.circleSize"
      :label-margin="widget.labelMargin"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import CirclesBar from './CirclesBar.vue';

export default {
  name: 'BarGraphWidgetView',
  components: {
    CirclesBar,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        zIndex: this.widget.zIndex,
        transform: `rotate(${this.widget.rotate}deg)`,
        background: this.widget.background,
        color: this.widget.color,
        fontSize: `${this.widget.fontSize}px`,
        fontFamily: this.widget.fontFamily,
        borderRadius: this.widget.borderRadius,
        padding: this.widget.padding,
      };
    },
    data() {
      try {
        const data = JSON.parse(this.widget.data);
        return _.isArray(data) ? data : [];
      } catch (e) {
        return [];
      }
    },
    valuesArray() {
      return _.chain(this.data)
        .sortBy(obj => obj.key)
        .value();
    },
    scaledValues() {
      const max = Math.max(...this.valuesArray.map(value => value.val));
      return this.valuesArray.map(value => ({
        length: Math.ceil((value.val / max) * 6),
        ...value,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-graph-widget {
  position: absolute;
  display: flex;
  direction: rtl;
  .bar {
    margin-right: 10px;
  }
}
</style>
